import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from './icons';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
  <nav aria-label="Breadcrumb" className="mb-6">
    <ol className="flex flex-wrap items-center gap-1.5 text-sm text-ink-muted">
      <li>
        <Link to="/" className="hover:text-ink-secondary transition-colors">
          Home
        </Link>
      </li>
      {items.map((item, i) => (
        <li key={i} className="flex items-center gap-1.5">
          <ChevronRight className="w-3 h-3 text-ink-faint" />
          {item.to ? (
            <Link to={item.to} className="hover:text-ink-secondary transition-colors">
              {item.label}
            </Link>
          ) : (
            <span aria-current="page" className="text-ink-secondary font-medium">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumb;
